// Color constants for the BHA application

export const COLORS = {
  // Primary colors - Black Heart Association brand
  $mainBlack: '#000000', // BHA black - primary brand color
  $charcoalBlack: '#1a1a1a', // Slightly lighter black for backgrounds
  $darkGray: '#2d2d2d', // Dark gray for gradients
  $mediumGray: '#333333', // Medium gray for hover states
  // Accent colors - Tiffany blue for highlights
  $mainTiffany: '#4ECDC4',   // BHA tiffany blue - primary accent color
  $brightTiffany: '#5AD6CE', // Brighter tiffany for highlights
  $darkTiffany: '#40B2A6',   // Darker tiffany for pressed states
  $deepTiffany: '#2E8B8B',   // Deep tiffany for medical context
  
  // Primary blue for buttons and interactive elements
  $primaryBlue: '#1890FF',   // Professional blue for primary actions
  $primaryBlueHover: '#40A9FF', // Hover state for primary blue
  $primaryBlueDark: '#096DD9',  // Dark state for primary blue
  
  // Legacy red colors (keeping for medical alerts/critical states)
  $alertRed: '#E31B23',   // For alerts and critical information only
  $bloodRed: '#8B0000',   // For medical emergencies
  
  // Theme colors
  $colorPrimary: '#000000', // Primary color for theme (black)
  $colorSecondary: '#4ECDC4', // Secondary color for theme (tiffany blue)
  $white: '#FFFFFF',     // Pure white
    // Gradient combinations
  gradient: {
    blackPrimary: 'linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #2d2d2d 100%)',
    blackSecondary: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 50%, #000000 100%)',
    tiffanyAccent: 'linear-gradient(135deg, #4ECDC4 0%, #5AD6CE 50%, #40B2A6 100%)',
    blackToTiffany: 'linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #4ECDC4 100%)',
    darkToLight: 'linear-gradient(135deg, #000000 0%, #333333 100%)',
    subtleGray: 'linear-gradient(135deg, #f8f8f8 0%, #ffffff 100%)',
    tiffanyBlackFade: 'linear-gradient(135deg, #4ECDC4 0%, #2E8B8B 50%, #000000 100%)'
  },
  
  // Background colors
  background: '#FFFFFF',
  backgroundLight: '#F8F8F8',
  backgroundDark: '#1a1a1a',
  backgroundMedium: '#2d2d2d',
  
  // Text colors
  textDark: '#262626',
  textMedium: '#333333',
  textLight: '#666666',
  textMuted: '#999999',
  textWhite: '#FFFFFF',
  
  // State colors
  success: '#28A745',
  warning: '#FFC107',
  error: '#DC3545',
  info: '#17A2B8',
  
  // UI element colors
  border: '#E0E0E0',
  borderDark: '#333333',
  cardShadow: 'rgba(0, 0, 0, 0.1)',
  cardShadowDark: 'rgba(0, 0, 0, 0.3)',  focusRing: 'rgba(78, 205, 196, 0.25)', // Tiffany blue focus ring
  
  // Medical/Health colors
  primaryAccent: '#4ECDC4',  // BHA tiffany blue
  heartRed: '#E31B23',  // BHA heart red (for alerts only)
  healthyGreen: '#4CAF50',
  warningAmber: '#FF9800',
  criticalRed: '#F44336',
  
  // Legacy support (keeping for backward compatibility)
  $mainBlue: '#007bff',
  $blueShades98: '#E6F0F9',
  $blueShades96: '#DEE8F7',
  $blueShades92: '#C8DCF4'
};

// For backwards compatibility
export const colors = COLORS;

export default COLORS;